module.exports = __webpack_public_path__ + "assets/events_health_white.1c4ed43b.svg";